export enum RideStatus {
  requested = 'requested',
  accepted = 'accepted',
  driverArrived = 'driver_arrived',
  inProgress = 'in_progress',
  awaitingCheckout = 'awaiting_checkout',
  completed = 'completed',
  cancelled = 'cancelled',
}

export enum UserStatus {
  active = 'active',
  suspended = 'suspended',
  blocked = 'blocked',
  pending = 'pending',
  deleted = 'deleted',
}

export interface Ride {
  _id: string;
  rideId: string;
  driverId?: string;
  customerId: string;
  customerAverageRating?: number;
  driverAverageRating?: number;
  customerName?: string;
  customerPhoneNumber?: string;
  customerFirstName?: string;
  customerLastName?: string;
  customerProfilePictureUrl?: string;
  customerStatus?: keyof typeof UserStatus;
  driverName?: string;
  driverPhoneNumber?: string;
  driverFirstName?: string;
  driverLastName?: string;
  driverProfilePictureUrl?: string;
  driverStatus?: keyof typeof UserStatus;
  pickup: {
    address: string;
    longitude: number;
    latitude: number;
  };
  destination: {
    address: string;
    longitude: number;
    latitude: number;
  };
  pricing: {
    estimatedFare?: number;
    finalFare?: number;
    currency: string;
  };
  route?: {
    estimatedDistance?: number;
    estimatedDuration?: number;
    actualDuration?: number;
  };
  timeline: {
    requestedAt?: Date;
    acceptedAt?: Date;
    pickedUpAt?: Date;
    completedAt?: Date;
    cancelledAt?: Date;
  };
  status: RideStatus;
  paymentMethod?: string;
  luggage?: boolean;
  pet?: boolean;
  specialInstructions?: string;
  customerRating?: number;
  driverRating?: number;
  refusedByDrivers?: string[];
  refusedByCustomer?: string[];
  createdAt: Date;
  updatedAt: Date;
  pickupAddress?: string;
  destinationAddress?: string;
  pickupLat?: number;
  pickupLng?: number;
  destinationLat?: number;
  destinationLng?: number;
  price?: number;
  distance?: number;
  startedAt?: Date;
  completedAt?: Date;
  cancelledAt?: Date;
  cancellationReason?: string;
  cancelledBy?: string;
}
